import axios from "axios";
import { Message, MessageBox } from "element-ui";

// create an axios instance
const service = axios.create({
  baseURL: "/xunbu-api", // api 的 base_url
  timeout: 15000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    config.baseURL = config.notNeedSuffix
      ? config.baseURL
      : config.baseURL + "/m.api";
    return config;
  },
  (error) => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    Message({
      message: error + "（请联系系统管理员）",
      type: "error",
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);

export default service;
